export const navigateToItemManagement = (id: string): void => {
  const domain = window.env.IMW_DOMAIN;
  const url = `${domain}/item/${id}`;
  window.location.replace(url);
};
